import React from 'react';
import { Island } from '@trevor/ui-components';
import {
  BAR,
  BARLINE,
  LINE,
  PIE,
  PIVOT,
} from '@/components/charting/chartType.constants';
import { useGetQueryBuilderSummarizeConfig } from '@/features/queryConfig/hooks/useGetQueryBuilderSummarizeConfig';
import { SINGLE_VALUE } from '@/components/ChartHolder.constants';
import { useDispatchUpdatesToMetricConfig } from '@/features/queryMetricsDimensionsConfig/hooks/useDispatchUpdatesToMetricConfig';
import { useHeadings_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import { useDataPresentationParam } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import {
  Bar,
  BarLine,
  EditQuery,
  Line,
  Pie,
  Pivot,
  SingleValue,
  Stacked,
  Table,
} from './router-buttons';

const useAvailablePresentations = () => {
  const { data, isReady } = useGetQueryBuilderSummarizeConfig();
  const headings = useHeadings_LEGACY();

  const hasData = isReady && !!headings && !!data;

  return hasData ? Object.keys(data) : [];
};

const useRedirectToQueryResultsWhenDataPresentationIsInvalid = () => {
  const { isReady } = useGetQueryBuilderSummarizeConfig();
  const selectedDataPresentation = useDataPresentationParam();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const availablePresentations = useAvailablePresentations();

  React.useEffect(() => {
    if (
      isReady &&
      selectedDataPresentation &&
      selectedDataPresentation !== 'table' &&
      !availablePresentations.includes(selectedDataPresentation)
    ) {
      navigate(pathname.replace(`/${selectedDataPresentation}`, ''));
    }
  }, [isReady, selectedDataPresentation, availablePresentations, pathname]);
};

export const RouterPresentationNavigation = () => {
  useDispatchUpdatesToMetricConfig();

  const availablePresentations = useAvailablePresentations();

  useRedirectToQueryResultsWhenDataPresentationIsInvalid();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '16px',
        fontSize: '14px',
      }}
    >
      <Island size="big">
        <EditQuery />
        <Table />
        <Pivot available={availablePresentations.includes(PIVOT)} />
        <SingleValue
          available={availablePresentations.includes(SINGLE_VALUE)}
        />
        <Pie available={availablePresentations.includes(PIE)} />
        <Bar available={availablePresentations.includes(BAR)} />
        <Line available={availablePresentations.includes(LINE)} />
        <BarLine available={availablePresentations.includes(BARLINE)} />
        <Stacked available={availablePresentations.includes('stacked')} />
      </Island>
    </div>
  );
};
